import React from 'react';
import { Link } from 'react-router-dom';
import { Nav } from 'react-bootstrap';

const Footer = () => {
    return (
        <>
            <div className="Footer py-5 bg-dark text-white">
                <div className="container">
                    <div className="row">

                        {/* PicAura Brand */}
                        <div className="col-md-6 col-lg-5 col-12 mb-4">
                            <h3 className="fw-bold" style={{ color: '#d50039', fontSize: '4rem' }}>PicAura</h3>
                            <p>Smart Photo Organization for Studios Using Facial Recognition</p>
                        </div>

                        {/* Quick Links */}
                        <div className="col-md-6 col-lg-2 col-12 mb-4">
                            <h5 className="fw-bold" style={{ color: '#d50039' }}>Quick Links</h5>
                            <ul className="list-unstyled">
                                <li className="nav-item mb-2">
                                    <Nav.Link as={Link} to="/" className="text-white p-0">Home</Nav.Link>
                                </li>
                                <li className="nav-item mb-2">
                                    <Nav.Link as={Link} to="/login" className="text-white p-0">Login</Nav.Link>
                                </li>
                                <li className="nav-item mb-2">
                                    <Nav.Link as={Link} to="/about" className="text-white p-0">About</Nav.Link>
                                </li>
                            </ul>
                        </div>

                        {/* Contact Us */}
                        <div className="col-md-6 col-lg-4 col-12 mb-4">
                            <h5 className="fw-bold" style={{ color: '#d50039' }}>Contact Us</h5>
                            <p className="mb-1">
                                <a
                                    href="https://wa.me/918459237357"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-white text-decoration-none"
                                >
                                    WhatsApp: +919422538012
                                </a>
                            </p>
                            <p>
                                <a
                                    href="mailto:info@3mi.info"
                                    className="text-white text-decoration-none"
                                >
                                    Email: info@3mi.info
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Footer */}
            <div className="Last-footer bg-secondary text-center py-3 text-white">
                <p className="mb-0">Designed by Neha & Shraddha (Three Musketeers Infotech)</p>
            </div>
        </>
    );
};

export default Footer;
